import { useMutation } from '@tanstack/vue-query';

import http from '@/services/http';
import { feedEndpoints, unwrapBody } from '@/queries/feed/client';

async function fetchHalykUserInfo() {
  const response = await http.get(feedEndpoints.halykUserInfo);
  return unwrapBody(response.data);
}

export function useHalykUserInfoMutation() {
  return useMutation({
    mutationFn: fetchHalykUserInfo
  });
}
